import { CLEAR_STORE } from '@/index.Dux'

import { put, takeLeading } from 'redux-saga/effects'
import { updateServices } from '../../utilities/actions'

const initialAuthState = {
  isFetching: false,
  isAuthenticated: false,
}
const authReducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case ADMIN_SIGNIN_SUCCESS: {
      return {
        permissions: [],

        isAuthenticated: true,

        isProfessional: false,
        isAdmin: true,

        isSuperAdmin: action.auth.profile.type === 'super-admin',
        isProviderAdmin: action.auth.profile.type === 'provider' || action.auth.profile.type === 'PaaS',
        isCompanyAdmin: action.auth.profile.type === 'company' || action.auth.profile.type === 'PaaS',

        jwtToken: action.auth.access_token,
        profile: action.auth.profile,

        //ToDo: remove user key and use profile instead (selectors)
        user: action.auth.profile,

        //TODO: DEPRECATE USAGE OF COMPANIES FROM AUTH
        roles: [{ name: action.auth.profile.type }],
        companies: action.companies,
      }
    }

    case REFRESH_ADMIN_AUTH_TOKEN: {
      return { ...state, jwtToken: action.access_token }
    }
    case UPDATE_PASSWORD: {
      return {
        ...state,
        jwtToken: action.jwtToken,
        profile: { ...state.profile, must_change_password: 0 },
      }
    }

    default:
      return state
  }
}

export const ADMIN_SIGNIN_SUCCESS = 'ADMIN_SIGNIN_SUCCESS'
export const adminSignInSuccess = (auth) => ({
  type: ADMIN_SIGNIN_SUCCESS,
  companies: auth.company ? [auth.company] : [],
  auth,
})

export const REFRESH_ADMIN_AUTH_TOKEN_TRIGGER = 'REFRESH_ADMIN_AUTH_TOKEN_TRIGGER'
export const refreshAdminAuthTokenTrigger = (access_token) => ({
  type: REFRESH_ADMIN_AUTH_TOKEN_TRIGGER,
  access_token,
})

export const REFRESH_ADMIN_AUTH_TOKEN = 'REFRESH_ADMIN_AUTH_TOKEN'
export const refreshAdminAuthToken = (access_token) => ({
  type: REFRESH_ADMIN_AUTH_TOKEN,
  access_token,
})

export const SIGNOUT_TRIGGER = 'SIGNOUT_TRIGGER'
export const signOutTrigger = () => ({
  type: SIGNOUT_TRIGGER,
})

export const UPDATE_SELF_PROFILE = 'UPDATE_SELF_PROFILE'
export const updateSelfProfile = (profile) => ({
  type: UPDATE_SELF_PROFILE,
  profile,
})

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'
export const updatePassword = (jwt) => ({
  type: UPDATE_PASSWORD,
  jwtToken: jwt,
})

export const adminSignOut = () => ({
  type: CLEAR_STORE,
})

//SAGA
export function* authSaga() {
  yield takeLeading(REFRESH_ADMIN_AUTH_TOKEN_TRIGGER, refreshAdminAuthTokenMiddleware)
}

export function* refreshAdminAuthTokenMiddleware(action) {
  try {
    const { access_token } = action
    updateServices(access_token)
    return yield put(refreshAdminAuthToken(access_token))
  } catch (e) {
    window.alert(JSON.stringify(e.message, null, 2))
    console.error(e)
  }
}

export default authReducer

// SELECTORS
export const getSelf = (state) => state.auth

export const selectJWT = (state) => state.auth.jwtToken
export const selectProfile = (state) => state.auth.profile
export const selectRole = (state) => state.auth.profile.type

export const selfIsProviderAdmin = (state) => state.auth.isProviderAdmin
export const selfIsCompanyAdmin = (state) => state.auth.isCompanyAdmin
export const selfIsSuperAdmin = (state) => state.auth.isSuperAdmin

export const selectSelfCompanies = (state) => (selfIsCompanyAdmin(state) ? state.auth.companies : [])
export const selectSelfProvider = (state) => (selfIsProviderAdmin(state) ? state.auth.profile.provider : undefined)
